import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values_women_owned: FaireCategoryEntity = {
  token: "cat_brand-values-women-owned",
  type: "category",
  name: "Women-owned",
  level: 2,
  parentToken: "cat_brand-values",
  href: "/category/women-owned",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
